module.exports = __webpack_public_path__ + "static/media/codeQuoter.1ef60f28.svg";